import type { ImageMetadata } from '../types/metadata.js';

/**
 * Technical metadata helpers shared by the `dpi` and `color_profile` checks.
 *
 * The modules below only interpret what the file already declares; they never
 * measure pixels and never turn a declared value into a different quantity.
 */
export * from './dpi.js';
export * from './colorProfile.js';

/**
 * Confidence of a verdict that rests on parsed container metadata.
 *
 * A successfully parsed container is trusted fully. A container whose format we
 * could not parse at all is still reported honestly, but at half confidence.
 */
export const metadataConfidence = (metadata: ImageMetadata): number =>
  metadata.notes.includes('metadata-format-unparsed') ? 0.5 : 1;
